<template>
    <input class="input-text input-time" type="text" ref="timeInput"
           :name="name"
           :value="value"
           @input="updateDate()"
           @change="$emit('change')"
           @blur="$emit('blur')"
           @focus="$emit('focus')"/>
</template>

<script>
    import $ from 'jquery'
    import '../assets/BootstrapTimepicker/bootstrap-timepicker'

    export default {
        name: "input-time",
        props: ['name', 'value', 'showSeconds', 'maxHours'],

        data(){
            return {

            }
        },

        methods:{
            updateDate(){
                this.$emit('input', this.$refs.timeInput.value);
            },

            setTime(time){
                $(this.$el).timepicker('setTime', time);
            }
        },

        mounted () {
            let that = this;
            this.$nextTick(() => {
                $(this.$el).timepicker({
                    defaultTime: false,
                    showMeridian: false,
                    maxHours: this.maxHours,
                    minuteStep: 1,
                    icons: {
                        up: 'timepicker-icon-up',
                        down: 'timepicker-icon-down'
                    },
                    showSeconds: this.showSeconds
                }).on('changeTime.timepicker', function(){
                    that.updateDate();
                });
            })
        },

        // destroyed(){
        //     $(this.$el).data('datetimepicker').destroy();
        // }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Content/src/components/InputTime.vue